<template>
  <section class="module-banner-ad">
    <div class="columns">
      <div class="column">
        <a href="https://www.tvp.info/aplikacja" class="module-banner-ad__content">
          <img
            v-if="isMobile"
            src="@/assets/images/banner/app_banner_news_mobile.png"
            alt="Aplikacja"
            title="baner"
          />
          <img
            v-else
            src="@/assets/images/banner/app_banner_news.png"
            alt="Aplikacja"
            title="baner"
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useBreakpoint } from '@/composables/useBreakpoints'
const { isMobile } = useBreakpoint()
</script>

<style lang="scss">
@import '@/assets/scss/components/modules/module-banner-ad.scss';
</style>
